import convertFormData from '@module/utils/convertFormData';
import { fetchExtended } from '../../../utils/fetch/client-fetch';
import { getFormData } from '../../../utils/getFormData';
import type { ApiBaseResponse } from '../../type';
import type {
  BjAdminNoticeDetailParams,
  BjAdminNoticeDetailResponse,
  BjAdminNoticeListParams,
  BjAdminNoticeListResponse,
  BjNoticeDeleteParams,
  BjNoticeEditParams,
  BjNoticeIndexParams,
  BjNoticeListParams,
  BjNoticeListResponse,
  BjNoticeWriteParams,
} from './type';

export const fetchBjAdminNoticeList = async (bjAdminNoticeListParams: BjAdminNoticeListParams) => {
  const res = await fetchExtended(`/v1/notice/bj_notice_list`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(bjAdminNoticeListParams),
  });

  const result = await res.json();

  return result as BjAdminNoticeListResponse;
};

export const fetchBjAdminNoticeDetail = async (bjAdminNoticeDetailParams: BjAdminNoticeDetailParams) => {
  const res = await fetchExtended(`/v1/notice/bj_notice_info`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(bjAdminNoticeDetailParams),
  });

  const result = await res.json();

  return result as BjAdminNoticeDetailResponse;
};

export const fetchBjNoticeList = async (bjNoticeParams: BjNoticeListParams) => {
  const res = await fetchExtended(`/v1/bj_notice`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(bjNoticeParams),
  });

  const result = await res.json();

  return result as BjNoticeListResponse;
};

export const fetchBjNoticeIndex = async (params: BjNoticeIndexParams) => {
  const res = await fetchExtended(`/v1/bj_notice/index`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(params),
  });

  const result = await res.json();

  return result as BjNoticeListResponse;
};

export const fetchBjNoticeWrite = async (bjNoticeWriteParams: BjNoticeWriteParams) => {
  const res = await fetchExtended(`/v1/bj_notice/write`, {
    method: 'POST',
    credentials: 'include',
    body: bjNoticeWriteParams.main ? getFormData(bjNoticeWriteParams) : convertFormData(bjNoticeWriteParams),
  });

  const result = await res.json();

  return result as ApiBaseResponse;
};

export const fetchBjNoticeEdit = async (bjNoticeEditParams: BjNoticeEditParams) => {
  const res = await fetchExtended(`/v1/bj_notice/edit`, {
    method: 'POST',
    credentials: 'include',
    body: bjNoticeEditParams.main ? getFormData(bjNoticeEditParams) : convertFormData(bjNoticeEditParams),
  });

  const result = await res.json();

  return result as ApiBaseResponse;
};

export const fetchBjNoticeDelete = async (bjNoticeDeleteParams: BjNoticeDeleteParams) => {
  const res = await fetchExtended(`/v1/bj_notice/delete`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(bjNoticeDeleteParams),
  });

  const result = await res.json();

  return result as ApiBaseResponse;
};
